module.exports = __webpack_public_path__ + "img/face-thinking.9bb34dff.svg";